import Vue from 'vue';

import {
  BContainer,
  BJumbotron,
  VBToggle,
  BCollapse,
  BCard,
  BCardHeader,
  BCardBody,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BDropdownItem,
  BNavbar,
  BNavbarNav,
  BNavbarBrand,
  BNavItemDropdown,
  BNavItem,
  BTab,
  BTabs,
  //BFormDatepicker,
  BForm,
  BFormRow,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BFormSelectOptionGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BFormCheckboxGroup,
  BDropdown,
  BButton,
  BRow,
  BCol,
  BModal,
  VBModal,
  ModalPlugin,
  BAlert,
  BIconEyeSlash,
  BIconEyeFill
} from 'bootstrap-vue';

import Vuelidate from 'vuelidate';
import moment from 'moment';

import App from './App.vue';

//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-datepicker/index.css';
import '@/css/common.css';

//  import 'promise-polyfill/src/polyfill';
import VueCookies from 'vue-cookies';
import router     from './router';
import store      from './store';

import rounding          from './filters/rounding';
import dollarValue       from './filters/dollarValue';
import reportFieldSource from '@/filters/reportFieldSource';
import booleanTrueFalse  from '@/filters/booleanTrueFalse';

Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.use(ModalPlugin);

// TODO-BUNDLE: Figure out how to use BootstrapVue plugins to minimize the manual efforts
Vue.component('b-jumbotron', BJumbotron);
Vue.component('b-container', BContainer);
Vue.component('b-collapse', BCollapse);
Vue.directive('b-toggle', VBToggle);

Vue.component('b-card', BCard);
Vue.component('b-card-header', BCardHeader);
Vue.component('b-card-body', BCardBody);
Vue.component('b-card-text', BCardText);

Vue.component('b-input-group', BInputGroup);
Vue.component('b-input-group-append', BInputGroupAppend);
Vue.component('b-dropdown-item', BDropdownItem);

Vue.component('b-navbar', BNavbar);
Vue.component('b-navbar-nav', BNavbarNav);
Vue.component('b-nav-item', BNavItem);
Vue.component('b-navbar-brand', BNavbarBrand);
Vue.component('b-nav-item-dropdown', BNavItemDropdown);

Vue.component('b-tab', BTab);
Vue.component('b-tabs', BTabs);

//Vue.component('b-form-datepicker', BFormDatepicker);
Vue.component('b-form', BForm);
Vue.component('b-form-row', BFormRow);
Vue.component('b-form-file', BFormFile);
Vue.component('b-form-group', BFormGroup);
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-textarea', BFormTextarea);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-form-select-option', BFormSelectOption);
Vue.component('b-form-select-option-group', BFormSelectOptionGroup);
Vue.component('b-form-radio-group', BFormRadioGroup);
Vue.component('b-form-radio', BFormRadio);
Vue.component('b-form-checkbox', BFormCheckbox);
Vue.component('b-form-checkbox-group', BFormCheckboxGroup);
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-button', BButton);
Vue.component('b-btn', BButton);
Vue.component('b-row', BRow);
Vue.component('b-col', BCol);
Vue.component('b-modal', BModal);
Vue.directive('b-modal', VBModal);
Vue.component('b-alert', BAlert);
Vue.component('b-icon-eye-slash', BIconEyeSlash);
Vue.component('b-icon-eye-fill', BIconEyeFill);

Vue.filter('rounding', rounding);
Vue.filter('dollarValue', dollarValue);
Vue.filter('reportFieldSource', reportFieldSource);
Vue.filter('booleanTrueFalse', booleanTrueFalse);

Vue.config.productionTip = false;

declare const window: Window &
  typeof globalThis & {
  CRTHUB: any
};

window.CRTHUB = new Vue(<any>{
  el: '#app',
  data: {
    settlementDate: new Date(),
    BondAnalysisSingleResults: {
      price: '',
      yield: '',
      spread: '',
      wal: '',
      principalWindow: '',
      writedownPct: '',
      firstLossPeriod: '',
      cashflow: ''
    },
    BondAnalysisMatrixResults: {
      price: [[]],
      yield: [[]],
      spread: [[]]
    },
    setSettlementDate: function (settlementDate) {
      this.settlementDate = settlementDate;
      Vue.$cookies.set('settlementDate', settlementDate);
    },
    setBondAnalysisSingleResults: function (price, yld, spread, wal, principalWindow, writedownPct, firstLossPeriod, cashflow) {
      this.BondAnalysisSingleResults.price           = price;
      this.BondAnalysisSingleResults.yield           = yld;
      this.BondAnalysisSingleResults.spread          = spread;
      this.BondAnalysisSingleResults.wal             = wal;
      this.BondAnalysisSingleResults.principalWindow = principalWindow;
      this.BondAnalysisSingleResults.writedownPct    = writedownPct;
      this.BondAnalysisSingleResults.firstLossPeriod = firstLossPeriod;
      this.BondAnalysisSingleResults.cashflow        = cashflow;
    },
    setBondAnalysisMatrixResults: function (price, yld, spread, wal, writeDown) {
      this.BondAnalysisMatrixResults.price     = price;
      this.BondAnalysisMatrixResults.yield     = yld;
      this.BondAnalysisMatrixResults.spread    = spread;
      this.BondAnalysisMatrixResults.wal       = wal;
      this.BondAnalysisMatrixResults.writeDown = writeDown;
    },
    clearBondAnalysisSingleResults() {
      this.BondAnalysisSingleResults.price           = '';
      this.BondAnalysisSingleResults.yield           = '';
      this.BondAnalysisSingleResults.spread          = '';
      this.BondAnalysisSingleResults.wal             = '';
      this.BondAnalysisSingleResults.principalWindow = '';
      this.BondAnalysisSingleResults.writedownPct    = '';
      this.BondAnalysisSingleResults.firstLossPeriod = '';
      this.BondAnalysisSingleResults.cashflow        = '';
    },
    clearBondAnalysisMatrixResults() {
      this.BondAnalysisMatrixResults.price  = [[]];
      this.BondAnalysisMatrixResults.yield  = [[]];
      this.BondAnalysisMatrixResults.spread = [[]];
    },
    async confirmCurrentStep(msg = 'Are you sure?') {
      let res = await this.$bvModal.msgBoxConfirm(msg, {
        title: '',
        size: 'md',
        buttonSize: 'lg',
        okVariant: 'success',
        cancelVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true
      })
        .then(value => {
          return value;
        })
        .catch(err => {
          return false;
        });
      return res;
    },
    async redirectToDealCatalog() {
      this.$router.push({ path: 'deal_catalog' });
    }
  },
  created: function() {
    this.$data.settlementDate = new Date();
    const savedSettlementDate = this.$cookies.get('settlementDate');
    if (savedSettlementDate != null) {
      const _date = new Date(savedSettlementDate);
      if (_date.toString() !== 'Invalid Date') {
        this.$data.settlementDate = _date;
      }
    }
  },
  store,
  router,
  render: h => h(App)
})
  .$mount('#app');
